import qs from "qs"

const options = {
    allowPrototypes: true,
    encodeValuesOnly: true,
    sort: (a: string, b: string) => a.localeCompare(b), // parameter display sequence by A-Z
    allowDots: true,
    // ignoreQueryPrefix: true,
    // delimiter: ';',
    // arrayFormat: "brackets"
    arrayFormat: "repeat"
}

const parse = (val: string) => qs.parse(val, options)

const stringify = (query: any) => qs.stringify(query, options as any)

const query = () => parse(window.location.search.replace("?", "")) || {}

export { options, parse, stringify, query }

export default {
    options,
    parse,
    stringify,
    query
}
